// 키워드별 소유 호스트 ID — 해당 호스트만 사용 가능
const KEYWORD_OWNER_HOST: Record<string, string> = {
  러바인: '28758',
  비긴어게인: '21173',
};

export const hasForbiddenKeyword = (
  hostId: string | number | undefined,
  inputValue: string,
): boolean => {
  const currentHostId = hostId === undefined || hostId === null ? '' : String(hostId);

  const tokens = inputValue
    .split(',')
    .map(item => item.trim())
    .filter(item => item !== '');

  return tokens.some(token => {
    const ownerHostId = KEYWORD_OWNER_HOST[token];
    return ownerHostId !== undefined && ownerHostId !== currentHostId;
  });
};

export const FORBIDDEN_KEYWORD_TOAST_MESSAGE =
  '사용 불가능한 태그명이 포함되어있습니다.';
